let lastMouseMove = new Date().getTime();
let lastMouseX;
let lastMouseY;

export function updateMouseMoved(p) {
  if (p.mouseX !== lastMouseX || p.mouseY !== lastMouseY) {
    lastMouseMove = new Date().getTime();
    lastMouseX = p.mouseX;
    lastMouseY = p.mouseY;
  }
}

export default function mouseMovedInLast2Seconds(p, nSeconds) {
  if (!lastMouseX) {
    return true;
  }

  if (p.mouseX !== lastMouseX || p.mouseY !== lastMouseY) {
    return true;
  }

  return new Date().getTime() - lastMouseMove < (nSeconds ? nSeconds * 1000 : 2000);
}



// WEBPACK FOOTER //
// ./src/sketches/mouse-moved-in-last-2-seconds.js